import { render, staticRenderFns } from "./comJb.vue?vue&type=template&id=07f179ea&scoped=true&"
import script from "./comJb.vue?vue&type=script&lang=js&"
export * from "./comJb.vue?vue&type=script&lang=js&"
import style0 from "./comJb.vue?vue&type=style&index=0&id=07f179ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f179ea",
  null
  
)

export default component.exports